/* @flow */
'use strict';

var _classCallCheck = require("/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _get = require("/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/get");

var _inherits = require("/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var Key = require('interface-datastore').Key;

var KeytransformDatastore = require('./keytransform');
/* ::
import type {Callback, Datastore, Query, QueryResult} from 'interface-datastore'
*/

/**
 * Wraps a given datastore into a keytransform which
 * makes a given prefix transparent.
 *
 * For example, if the prefix is `new Key(/hello)` a call
 * to `store.put(new Key('/world'), mydata)` would store the data under
 * `/hello/world`.
 *
 */


var NamespaceDatastore
/* :: <Value> */
=
/*#__PURE__*/
function (_KeytransformDatastor) {
  _inherits(NamespaceDatastore, _KeytransformDatastor);

  /* :: prefix: Key */
  function NamespaceDatastore(child
  /* : Datastore<Value> */
  , prefix
  /* : Key */
  ) {
    var _this;

    _classCallCheck(this, NamespaceDatastore);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(NamespaceDatastore).call(this, child, {
      convert: function convert(key
      /* : Key */
      )
      /* : Key */
      {
        return prefix.child(key);
      },
      invert: function invert(key
      /* : Key */
      )
      /* : Key */
      {
        if (prefix.toString() === '/') {
          return key;
        }

        if (!prefix.isAncestorOf(key)) {
          throw new Error("Expected prefix: (".concat(prefix.toString(), ") in key: ").concat(key.toString()));
        }

        return new Key(key.toString().slice(prefix.toString().length), false);
      }
    }));
    _this.prefix = prefix;
    return _this;
  }

  _createClass(NamespaceDatastore, [{
    key: "query",
    value: function query(q
    /* : Query<Value> */
    )
    /* : QueryResult<Value> */
    {
      if (q.prefix && this.prefix.toString() !== '/') {
        return _get(_getPrototypeOf(NamespaceDatastore.prototype), "query", this).call(this, Object.assign({}, q, {
          prefix: this.prefix.child(new Key(q.prefix)).toString()
        }));
      }

      return _get(_getPrototypeOf(NamespaceDatastore.prototype), "query", this).call(this, q);
    }
  }]);

  return NamespaceDatastore;
}(KeytransformDatastore
/* :: <Value> */
);

module.exports = NamespaceDatastore;